import 'whatwg-fetch';
import { resourcesRoot } from './constants/config';


const makeAbsoluteUrl = (resourcePath) => {
  return `${resourcesRoot}/${resourcePath}`;
};

const get = (resourcePath) => {
  console.log('fetch from', resourcesRoot, resourcePath);
  return fetch(makeAbsoluteUrl(resourcePath), { cache: 'no-cache' });
};

const post = (resourcePath, options) => {
  console.log('post to', resourcesRoot, resourcePath);
  return fetch(
    makeAbsoluteUrl(resourcePath),
    options
  );
};

export default {
  makeAbsoluteUrl,
  get,
  post,
};
